<template lang="pug">
  .container.my-5.mt-5.mx-5.px-5
    .columns
      .column.is-10
        form
          .field
            label.label.is-size-4.has-text-weight-light(for='name')
            .control.has-icons-left
              input#name.input(type='text' name='name' placeholder='Nombre' autofocus='')
              span.icon.is-left
                i.fa.fa-user
          .field
            label.label.is-size-4.has-text-weight-light(for='email')
            .control.has-icons-left
              input#email.input(type='email' name='email' placeholder='Email')
              span.icon.is-left
                i.fa.fa-envelope
          .field
            label.label.is-size-4.has-text-weight-light(for='phone')
            .control.has-icons-left
              input#email.input(type='phone' name='phone' placeholder='Teléfono')
              span.icon.is-left
                i.fa.fa-phone
          .field
            label.label.is-size-4.has-text-weight-light(for='message')
            textarea#message.textarea.is-medium(name='message' rows='5' placeholder='Mensaje')
          button.button.is-primary.is-size-5(type='submit') Enviar
</template>

<script>
  export default {
    name: 'FormContacto',
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/landing_Componentes/FormContacto.vue